import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthDataContext } from "components/auth";
import { trackUserAction } from "config/paths";

const doTrack = ({ action, user, location, token }) => {
  if (user) {
    fetch(trackUserAction(token), {
      method: "POST",
      body: JSON.stringify({
        action,
        location: location.pathname,
        queryParams: location.search,
      }),
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      mode: "cors",
    });
  }
};

export const useImperativeTracking = () => {
  const location = useLocation();
  const { user, token } = useAuthDataContext();

  return action => doTrack({ action, user, location, token });
};

export const useTracking = ({ action, condition = () => true }) => {
  const track = useImperativeTracking();

  useEffect(() => {
    if (condition()) {
      track(action);
    }
  });
};
